import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { MobileTopBar } from "company/GameScreen";
import { useAuthContext } from "context/GameAuthContext";
import { useRoomTemplateLoginPageContext } from "context/RoomTemplateContext";
import * as React from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { useIntl } from "react-intl";
import Details from "./details";
import { DetailsContainer, GameOverContainer, SummaryContainer } from "./styles";
import Summary from "./summary";
const ExitIcon = React.lazy(() => import("@mui/icons-material/ExitToApp"));

const GameOver: React.FC = () => {
	const { value: roomTemplate } = useRoomTemplateLoginPageContext();
	const gameOverContent = roomTemplate?.gameOverContent;

	const intl = useIntl();
	const classes = useStyles();
	const { logout } = useAuthContext();

	return (
		<>
			{isMobile && <MobileTopBar />}
			<GameOverContainer maxWidth={false}>
				<>
					<SummaryContainer>
						<Summary gameOverContent={gameOverContent} />
					</SummaryContainer>
					<DetailsContainer>
						<Details gameOverContent={gameOverContent} />
					</DetailsContainer>
					{isDesktop && (
						<Button data-testid="logout-btn" className={`${classes.logoutButton}`} onClick={logout}>
							{intl.formatMessage({ id: "USERDASHBOARD.header.logout" })} &nbsp;{" "}
							<ExitIcon className={`${classes.logoutIcon}`} />
						</Button>
					)}
				</>
			</GameOverContainer>
		</>
	);
};

export default GameOver;

const useStyles = makeStyles((theme) => ({
	logoutButton: {
		position: "absolute",
		top: 16,
		right: 20,
		backgroundColor: "transparent",
		border: `2px solid ${theme.palette.primary.main}`,
		color: theme.palette.primary.main,
		height: "fit-content",
		fontSize: "1rem",
		fontWeight: "bold",
		padding: "0 10px",
		textTransform: "none",
		"&:hover": {
			color: "black",
			backgroundColor: "white",
		},
	},
	logoutIcon: {
		width: 17.26,
		heigth: 14.85,
	},
}));
